import gql from "graphql-tag";


export default function query(params) {

    return gql`
        query {
            getSaltoGatewayById(id: "${params.id}") {
                errors
                gateway {
                    id
                    device_id
                    garage_id
                    master_id
                    type
                    gwid
                    product_type
                    node_number
                    relay_timings
                    note
                    name
                    position{
                        lat
                        long
                    }
                    created_at
                    updated_at
                    deleted_at
                    garage_gateway {
                        name
                        id
                        state
                        echarger
                    }
                    health_status {
                        nfc_state
                        ble_state
                        rf_state
                        connection
                        main_controller_state
                    }
                    tenant_id
                }
                
            }
        }`;
}
